import { Injectable } from '@angular/core';
import { Rpfi05DayRow, Rpfi05TableResult } from '../../models/report/rpfi05.model';

@Injectable({ providedIn: 'root' })
export class MapperRpfi05Service {
  mapTable(res: unknown): Rpfi05TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const list = (raw['rows'] ?? raw['Rows'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      startDate: (raw['startDate'] ?? raw['StartDate'] ?? null) as string | null,
      endDate: (raw['endDate'] ?? raw['EndDate'] ?? null) as string | null,
      rows: list.map((item) => this.mapRow(item)),
      totals: this.mapRow(raw['totals'] ?? raw['Totals'] ?? {}),
      unmappedAmount: Number(raw['unmappedAmount'] ?? raw['UnmappedAmount'] ?? 0),
    };
  }

  mapRow(dto: unknown): Rpfi05DayRow {
    const r = (dto ?? {}) as Record<string, unknown>;
    return {
      paidDate: (r['paidDate'] ?? r['PaidDate'] ?? null) as string | null,
      evCharging: Number(r['evCharging'] ?? r['EvCharging'] ?? 0),
      carParking: Number(r['carParking'] ?? r['CarParking'] ?? 0),
      carMember: Number(r['carMember'] ?? r['CarMember'] ?? 0),
      carLostCard: Number(r['carLostCard'] ?? r['CarLostCard'] ?? 0),
      carTotal: Number(r['carTotal'] ?? r['CarTotal'] ?? 0),
      mcParking: Number(r['mcParking'] ?? r['McParking'] ?? 0),
      mcMember: Number(r['mcMember'] ?? r['McMember'] ?? 0),
      mcLostCard: Number(r['mcLostCard'] ?? r['McLostCard'] ?? 0),
      mcTotal: Number(r['mcTotal'] ?? r['McTotal'] ?? 0),
      totalParking: Number(r['totalParking'] ?? r['TotalParking'] ?? 0),
      totalMember: Number(r['totalMember'] ?? r['TotalMember'] ?? 0),
      totalLostCard: Number(r['totalLostCard'] ?? r['TotalLostCard'] ?? 0),
      discountCard: Number(r['discountCard'] ?? r['DiscountCard'] ?? 0),
      estamp: Number(r['estamp'] ?? r['Estamp'] ?? 0),
      coupon: Number(r['coupon'] ?? r['Coupon'] ?? 0),
      grandTotal: Number(r['grandTotal'] ?? r['GrandTotal'] ?? 0),
    };
  }
}
